export class OrganigrammaIncaricatoDTO {
  nome: string;
  cognome: string;
  descrizione: string;
}
